/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：516
 */

module.exports = {
  courseMinIcon: "styles_courseMinIcon__1xPhh",
  close: "styles_close__1sIAC"
}
